export enum CollapsibleMessages {
  BUTTON_LABEL_COLLAPSE = 'View less',
  BUTTON_LABEL_EXPAND = 'View more',
}

export enum CollapsibleState {
  CLOSED = 'closed',
  OPEN = 'open',
}
